// https://caniuse.com/mdn-api_element_checkvisibility
// Safari is currently only unsupported browser and a polyfill does not seem to exist on the web
if (typeof HTMLElement.prototype.checkVisibility === 'undefined') {
  // eslint-disable-next-line func-names
  HTMLElement.prototype.checkVisibility = function () {
    const bounds = this.getBoundingClientRect();

    return !(
      bounds.width === 0 &&
      bounds.height === 0 &&
      bounds.x === 0 &&
      bounds.y === 0 &&
      bounds.top === 0 &&
      bounds.bottom === 0 &&
      bounds.left === 0 &&
      bounds.right === 0
    );
  };
}
